import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "../styles/Footer.css";
  import { FaWhatsapp, FaEnvelope, FaMapMarkerAlt  } from "react-icons/fa"; // Import WhatsApp and Email icons

const Footer = () => {
  return (
    <footer className="footer bg-dark text-light py-4">
      <Container>
        <Row className="align-items-start">
          {/* Left - Logo + About Us Section */}
          <Col xs={12} md={4} className="text-md-start text-left mb-4 mb-md-0">
            <img src="/logo1.png" alt="Logo" className="footer-logo" />
            <div className="about-us mt-3">
              <h5>About Us</h5>
              <p>
                We are committed to providing high-quality services. 
                Our expertise spans various industries, ensuring excellence in every project.
              </p>
            </div>
          </Col>

          {/* Center - Services Section */}
          <Col xs={12} md={4} className="text-left mb-4 mb-md-0 footer-service">
            <h5>Our Services</h5>
            <ul className="list-unstyled">
              <li>Assets Recovery</li>
              <li>Reverse Logistics</li>
              <li>Distribution Services</li>
              <li>Supply Chain Fulfillment</li>
              <li>Recycling Services</li>
              <li>Processes Services</li>
              <li>Data Sanitization</li>
            </ul>
          </Col>

          {/* Right - Contact Info Section */}
          <Col xs={12} md={4} className="text-left mb-4 mb-md-0">
            <h5>Contact Info</h5>
             <p><FaWhatsapp color="green" size={20} /> +995-571075228</p>
            <p><FaWhatsapp color="green" size={20} /> +995-504220383</p>
                    <p><FaEnvelope color="red" size={20} /> Info@bhanottrade.com</p>
            <p>
            <FaMapMarkerAlt size={20} style={{ color: "gold" }} /> 
              Georgia, Tbilisi, Krtsanisi District <br />
              Nino and Ilia Nakashidze Street, N1 <br />
              Building N3, Apartment N3
            </p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;



// import React from 'react'
// import {Container, } from "react-bootstrap";

// // 4️⃣ FOOTER SECTION
// const Footer = () => {
//     return (
//       <footer className="bg-dark text-white text-center py-3">
//         <Container>
//           <p>Designed By <a href='https://www.litostindia.in/' className='text-light text-decoration-none'>@Litost India</a></p>
//         </Container>
//       </footer>
//     );
//   };

// export default Footer;